import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import abadjieva from "@baseImg/authors/abadjieva1.png";
import dpencheva from "@baseImg/authors/dpencheva.png";
import mmetodieva from "@baseImg/authors/mmetodieva.png";
import kstoyanov from "@baseImg/authors/kstoyanov.png";

const BG = {
	blockTitle: 'Избрано от блога',
	allText: '<a href="https://blog.superhosting.bg" target="_blank">Всички публикации от блога</a>',
	blockContent: [
		{
			title: `
				   <a href="https://blog.superhosting.bg/digital-maturity-of-businesses-in-europe-what-the-data-shows.html" target="_blank">
				   		Дигиталната зрялост на бизнеса в Европа: какво показват данните
				   </a>
				   `,
			name: 'Диана Пенчева',
			img: dpencheva
		},
		{
			title: `
				   <a href="https://blog.superhosting.bg/advanced-hosting-parameters-the-site-reliability.html" target="_blank">
				   		Как „скритите“ параметри в хостинг плана влияят на надеждността и стабилността на сайта Ви
				   </a>
				   `,
			name: 'Петя Абаджиева',
			img: abadjieva
		},
		{
			title: `
				   <a href="https://blog.superhosting.bg/wordpress-ai-assistant.html" target="_blank">
				   		Сайт асистент (AI): инструментът, който създава сайт на WordPress за минути
				   </a>
				   `,
			name: 'Мадлена Методиева',
			img: mmetodieva
		},
		{
			title: `
				   <a href="https://blog.superhosting.bg/gdpr-protect-iubenda.html" target="_blank">
				   		GDPR Протект: направете сайта си изряден спрямо GDPR изискванията
				   </a>
				   `,
			name: 'Мадлена Методиева',
			img: mmetodieva
		},
		{
			title: `
				   <a href="https://blog.superhosting.bg/best-practices-for-optimizing-wordpress.html" target="_blank">
				   		Добри практики за оптимизация на твоя WordPress сайт
				   </a>
				   `,
			name: 'Кристиан Стоянов',
			img: kstoyanov
		}
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: '',
	allText: '',
	blockContent: []
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];